import { render } from "./ViewsOrderSubmit.vue?vue&type=template&id=4599b11a"
import script from "./ViewsOrderSubmit.vue?vue&type=script&lang=js"
export * from "./ViewsOrderSubmit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__